import { createContext } from "react";
import type { PlanroomEditor } from "./editor";

/** The editor of Planroom's own canvas engine, when that engine is mounted. */
export const CanvasEditorContext = createContext<PlanroomEditor | null>(null);
